import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

//Context import
import AuthContext from "../../components/shared/Context";

const AddDiagnosisNameChild = () => {
  const {
    checkLoggedInStatus,
    loggedInUserDetails,
    selectedDiagnosis,
    states,
  } = useContext(AuthContext);
  let navigate = useNavigate();
  const [recordID, setRecordID] = useState(null);

  const [formData, setFormData] = useState({
    id: null,
    category_id: null,
    state: loggedInUserDetails?.state ? loggedInUserDetails?.state : null,
    label: null,
  });

  const [diagnosisCatOptions, setDiagnosisCatOptions] = useState();

  const stateOptions = states.map((state, index) => ({
    value: index,
    label: state,
  }));

  //Get Diagnosis Category Based on State
  useEffect(() => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    let urlLink = `${process.env.REACT_APP_API_URL}/dcat/state/${formData?.state}`;

    axios
      .get(urlLink, config)
      .then((res) => {
        const responseData = res?.data?.categories;
        //console.log(responseData);
        const diagnosesCatData = responseData.map((c) => ({
          value: c._id,
          label: c.category,
        }));
        setDiagnosisCatOptions(diagnosesCatData);
      })
      .catch((err) => console.log("error", err));
  }, [formData?.state]);

  //Next ID generated
  useEffect(() => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    let urlLink = `${process.env.REACT_APP_API_URL}/diagnosis/next-id/${formData?.state}`;

    axios
      .get(urlLink, config)
      .then((res) => {
        const responseData = res?.data?.nextId;
        console.log(responseData);
        setRecordID(responseData);
      })
      .catch((err) => console.log("error", err));
  }, [formData?.state]);

  //Set NExt ID
  useEffect(() => {
    setFormData({
      ...formData,
      id: recordID,
    });
  }, [recordID]);

  const addDiagnosis = () => {
    if (!formData.category_id) {
      toast.error("Please Add Category!");
      return;
    }

    if (loggedInUserDetails?.role === "FULL_ACCESS" && formData?.state === null)
      return toast.error("Please Select State!");

    let userToken = localStorage.getItem("token");
    const config = {
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/diagnosis/add`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData },
    };
    axios(config)
      .then(function (response) {
        toast.success("Diagonsis Created Successfully.");
        navigate("/diagnosis");
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error?.response?.data?.message));
        if (error.response.data.message.toLowerCase().includes("invalid")) {
          navigate("/login");
        }
      });
  };

  const handleChangeValue = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ height: "70vh" }}
    >
      <div className="col-md-6 mx-auto d-block d-flex signup-form">
        <form className="mt-1 border p-4 shadow w-100">
          <div className="row">
            <div className="">
              <h5 className="text-secondary">Create Diagnosis Category</h5>
              <hr />
              <br />
            </div>
          </div>
          {loggedInUserDetails?.role === "FULL_ACCESS" && (
            <div className="row">
              <div className="">
                <label>State</label>
                <Select
                  name="state"
                  onChange={
                    //dropDownChange
                    (selected, dropdown) => {
                      console.log(selected);
                      setFormData({
                        ...formData,
                        state: selected.label,
                        category_id: null,
                      });
                    }
                  }
                  className="newPatientSelect"
                  options={stateOptions}
                />
              </div>
            </div>
          )}
          <div className="row">
            <div className="">
              <label>Diagnosis Category</label>
              <Select
                name="category_id"
                onChange={
                  //dropDownChange
                  (selected, dropdown) => {
                    console.log(selected);
                    setFormData({
                      ...formData,
                      category_id: selected.value,
                    });
                  }
                }
                className="newPatientSelect"
                options={diagnosisCatOptions}
                value={
                  formData?.category_id
                    ? diagnosisCatOptions?.find(
                        (cat) => cat._id === formData?.category_id
                      )
                    : null
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="">
              <label>
                Enter ID<span className="text-danger">*</span>
              </label>
              <input
                type="number"
                name="id"
                className="form-control"
                placeholder="Diagnosis ID"
                onChange={handleChangeValue}
                value={formData?.id}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="">
              <label>
                Enter Diagnosis Name<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="label"
                className="form-control"
                placeholder="Diagnosis Name"
                onChange={handleChangeValue}
                value={formData?.label}
                required
              />
            </div>
          </div>
          <div className="flex flex-row mt-4">
            <div className="col-md-12">
              <Button
                variant="primary"
                size="medium"
                className="float-end"
                onClick={addDiagnosis}
              >
                Save
              </Button>
            </div>

            <div className="col-md-12">
              <Button
                variant="primary"
                size="secondary"
                className="float-start"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </div>
          </div>
        </form>
      </div>
      {/* {JSON.stringify(formData)} */}
    </div>
  );
};

export default AddDiagnosisNameChild;
